import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Change_pass() {
    const navigate = useNavigate();
    const [selectedComId, setSelectedComId] = useState('');
    const [selectedComName, setSelectedComName] = useState('');
    const [selectedComLogo, setSelectedComLogo] = useState('');
    const [selectedUserId, setSelectedUserId] = useState('');
    const [pass, setPass] = useState("");
    const [confPass, setConfPass] = useState("");

    useEffect(() => {
        var comname = localStorage.getItem('mem_company_name');
        setSelectedComName(comname);
        var comid = localStorage.getItem('mem_company_id');
        setSelectedComId(comid);
        var comlogo = localStorage.getItem('companylogo');
        setSelectedComLogo(comlogo);
        var userID = localStorage.getItem('member_id');
        setSelectedUserId(userID);

    }, []);

    const updateUserPass = async () => {
        const memid = localStorage.getItem("member_id");
        

        // Check if passwords are entered
        if(!pass.trim() || !confPass.trim()) {
            alert("Please enter both password fields.");
            return;
        }

        if (pass !== confPass) {
            alert("Password and Confirm Password do not match.");
            return;
        }


        try {
            const formData = new FormData();
            formData.append("memid", memid);
            formData.append("pass", pass);

            const response = await fetch(
                `changePassforMember.php`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            const result = (await response.text()).trim();

            if (result === "success") {
                alert("Password updated successfully.");

                // Clear the fields
                navigate('/logout');
            } else {
                alert("Failed to update password.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    return (
        <div>
            <div className='editbtn_holder'>
                <div className='membersinfoimg fullwidth'>
                    <div className='memberimgholder'>
                        <img id="memimg" src={selectedComLogo} />
                    </div>
                    <h2 id="companyname">{selectedComName}</h2>
                </div>
            </div>
            <div className='vl_dsh_one_full pos_rel' id="all_fields_holder">
                <div className='vl_dsh_formnholder pos_rel'>
                    <div className='center_form_box'>
                        <h2> Change your password</h2>
                        <div className='formfieldcommon'>
                            <label>Insert Password</label>
                            <input type="password" value={pass} onChange={(e) => setPass(e.target.value)} />
                        </div>
                        <div className='formfieldcommon'>
                            <label>Confirm Password</label>
                            <input type="password" value={confPass} onChange={(e) => setConfPass(e.target.value)} />
                        </div>
                        <div className='small_buttonholder'>
                            <button onClick={updateUserPass}>Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
